import { WayfindingPlay } from './wayfinding.models';

/** Generated by tools/crawl-wayfinding-plays.mjs. Do not edit by hand. */
export const CRAWLED_WAYFINDING_PLAYS: WayfindingPlay[] = [
  {
    id: 'play-crawled-growth-crm',
    titleKey: 'nav.capability.growthCrm',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سرنخ‌ها', 'Leads', 'بخش‌بندی', 'Segments', 'مشتری 360', 'Customer 360', 'growth', 'crm', 'leads', 'segments', 'customer', '360'],
    steps: [
      { route: '/growth/crm/leads', titleKey: 'nav.growth.leads', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/growth/crm/segments', titleKey: 'nav.growth.segments', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/crm/customer-360', titleKey: 'nav.growth.customer360', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-marketing',
    titleKey: 'nav.capability.growthCampaigns',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['دارایی‌های محتوا', 'Content Assets', 'استودیو ACE', 'ACE Content Studio', 'کمپین‌ها', 'Campaigns', 'تقویم محتوا', 'Content Calendar', 'صف تأیید', 'Approval Queue', 'بازبینی و تایید محتوا', 'Content review and approval', 'عملیات انتشار', 'Publish Operations', 'growth', 'marketing'],
    steps: [
      { route: '/growth/marketing/content-assets/new', titleKey: 'nav.growth.contentAssets', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/growth/marketing/ace-studio', titleKey: 'nav.growth.aceStudio', whyKey: 'wayfinding.liveStep.whyCreate', optional: true },
      { route: '/growth/marketing/campaigns', titleKey: 'nav.growth.campaigns', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/growth/marketing/content-calendar', titleKey: 'nav.growth.contentCalendar', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/growth/marketing/approval-queue', titleKey: 'nav.growth.approvalQueue', whyKey: 'wayfinding.liveStep.whyApprove', optional: true },
      { route: '/growth/marketing/article-publishing', titleKey: 'nav.growth.articlePublishing', whyKey: 'wayfinding.liveStep.whyApprove' },
      { route: '/growth/marketing/publish-operations', titleKey: 'nav.growth.publishOperations', whyKey: 'wayfinding.liveStep.whyPublish' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-journey',
    titleKey: 'nav.capability.growthCampaigns',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['کشف کسب‌وکار', 'Business Discovery', 'مسیرهای هدایت‌شده', 'Guided Journeys', 'پروفایل‌های صدای برند', 'Brand Voice Profiles', 'growth', 'journey', 'discoveries', 'journeys', 'brand', 'voice', 'profiles'],
    steps: [
      { route: '/growth/journey/discoveries', titleKey: 'nav.growth.businessDiscovery', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/journey/journeys', titleKey: 'nav.growth.guidedJourneys', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/journey/brand-voice-profiles', titleKey: 'nav.growth.brandVoiceProfiles', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-agents',
    titleKey: 'nav.capability.growthAgents',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['تعریف عامل', 'Agent Definitions', 'توصیه‌های عامل', 'Agent Recommendations', 'مصنوعات استراتژی', 'Strategy Artifacts', 'صف تأیید عامل', 'Agent Approval Queue', 'growth', 'agents', 'definitions', 'recommendations', 'strategy', 'artifacts', 'approval', 'queue'],
    steps: [
      { route: '/growth/agents/definitions', titleKey: 'nav.growth.agentDefinitions', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/agents/recommendations', titleKey: 'nav.growth.agentRecommendations', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/agents/strategy-artifacts', titleKey: 'nav.growth.strategyArtifacts', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/agents/approval-queue', titleKey: 'nav.growth.agentApprovalQueue', whyKey: 'wayfinding.liveStep.whyApprove', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-comms',
    titleKey: 'nav.growth.distributions',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['توزیع ایمیل/SMS', 'Email/SMS distribution', 'کانال‌های ارتباطی', 'Comms Channels', 'پست شبکه اجتماعی', 'Social Posts', 'growth', 'comms', 'distributions', 'channels', 'social', 'posts'],
    steps: [
      { route: '/growth/comms/distributions', titleKey: 'nav.growth.distributions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/comms/channels', titleKey: 'nav.growth.commsChannels', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/comms/social-posts', titleKey: 'nav.growth.socialPosts', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-integration',
    titleKey: 'nav.capability.growthOmnichannel',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['اتصال‌دهنده‌های یکپارچه‌سازی', 'Integration connectors', 'وضعیت sync یکپارچه‌سازی', 'Integration sync status', 'growth', 'integration', 'connectors', 'sync', 'status'],
    steps: [
      { route: '/growth/integration/connectors', titleKey: 'nav.growth.integrationConnectors', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/integration/sync-status', titleKey: 'nav.growth.integrationSyncStatus', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-paid-media',
    titleKey: 'nav.capability.growthOmnichannel',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['لینک‌های کمپین رسانه پولی', 'Paid media campaign links', 'حساب‌های رسانه پولی', 'Paid media accounts', 'همگام‌سازی مخاطب رسانه پولی', 'Paid media audience sync', 'ROAS رسانه پولی', 'Paid media ROAS', 'growth', 'paid', 'media', 'campaign', 'links', 'accounts', 'audience', 'sync'],
    steps: [
      { route: '/growth/paid-media/campaign-links', titleKey: 'nav.growth.paidMediaCampaignLinks', whyKey: 'wayfinding.liveStep.whyPlan' },
      { route: '/growth/paid-media/accounts', titleKey: 'nav.growth.paidMediaAccounts', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/paid-media/audience-sync', titleKey: 'nav.growth.paidMediaAudienceSync', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/paid-media/roas', titleKey: 'nav.growth.paidMediaRoas', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-intelligence',
    titleKey: 'nav.capability.growthIntelligence',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['انتساب', 'Attribution', 'قیف‌ها', 'Funnels', 'گروه‌های همگن', 'Cohorts', 'پیش‌بینی', 'Forecasts', 'growth', 'intelligence', 'attribution', 'funnels', 'cohorts', 'forecasts'],
    steps: [
      { route: '/growth/intelligence/attribution', titleKey: 'nav.growth.attribution', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/intelligence/funnels', titleKey: 'nav.growth.funnels', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/intelligence/cohorts', titleKey: 'nav.growth.cohorts', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/intelligence/forecasts', titleKey: 'nav.growth.forecasts', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-optimizer',
    titleKey: 'nav.capability.growthOptimizer',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['کنسول بهینه‌ساز', 'Optimizer Console', 'اجرای بهینه‌سازی', 'Optimization Runs', 'growth', 'optimizer', 'console', 'optimization', 'runs'],
    steps: [
      { route: '/growth/optimizer/console', titleKey: 'nav.growth.optimizerConsole', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/optimizer/optimization-runs', titleKey: 'nav.growth.optimizationRuns', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-twin',
    titleKey: 'nav.capability.growthTwin',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['دوقلو کسب‌وکار', 'Business Twin', 'سناریوها', 'Scenarios', 'growth', 'twin', 'business', 'scenarios'],
    steps: [
      { route: '/growth/twin/business-twin', titleKey: 'nav.growth.businessTwin', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/twin/scenarios', titleKey: 'nav.growth.scenarios', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-service',
    titleKey: 'nav.growth.successPlans',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['برنامه‌های موفقیت', 'Success Plans', 'بازی‌های نگه‌داشت', 'Retention Plays', 'growth', 'service', 'success', 'plans', 'retention', 'plays'],
    steps: [
      { route: '/growth/service/success-plans', titleKey: 'nav.growth.successPlans', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/growth/service/retention-plays', titleKey: 'nav.growth.retentionPlays', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-marketplace',
    titleKey: 'nav.capability.growthMarketplace',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['فهرست agentها', 'Agent listings', 'نصب agentها', 'Agent installs', 'نصب پک‌های صنعت', 'Industry pack installs', 'Industry bindings', 'growth', 'marketplace', 'listings', 'agent', 'installs', 'bindings'],
    steps: [
      { route: '/growth/marketplace/listings', titleKey: 'nav.growth.agentMarketplaceListings', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/marketplace/agent-installs', titleKey: 'nav.growth.agentMarketplaceInstalls', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/marketplace/installs', titleKey: 'nav.growth.industryPackInstalls', whyKey: 'wayfinding.liveStep.why' },
      { route: '/growth/marketplace/bindings', titleKey: 'nav.growth.industryBindings', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-platform-parties',
    titleKey: 'nav.capability.partyKindRegistry',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['اشخاص حقیقی', 'Individuals', 'سازمان‌ها', 'Organizations', 'اشیا و دستگاه‌ها', 'Devices & Things', 'ایجنت‌ها', 'AI Agents', 'ربات‌ها و سرویس‌ها', 'Services & Robots', 'platform', 'parties', 'kinds', 'individual', 'organization', 'device'],
    steps: [
      { route: '/platform/parties/kinds/individual', titleKey: 'nav.partyHub.individuals', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/platform/parties/kinds/organization', titleKey: 'nav.partyHub.organizations', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/platform/parties/kinds/device', titleKey: 'nav.partyHub.devices', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/platform/parties/kinds/ai-agent', titleKey: 'nav.partyHub.aiAgents', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/platform/parties/kinds/service', titleKey: 'nav.partyHub.services', whyKey: 'wayfinding.liveStep.whyCreate' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-inventory-costing',
    titleKey: 'nav.capability.inventoryCosting',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سیاست‌های بهای‌تمام‌شده', 'Costing Policies', 'ارزش‌گذاری موجودی', 'Inventory Valuation', 'لایه‌های هزینه', 'Cost Layers', 'تجدید ارزش موجودی', 'Cost Revaluations', 'عملیاتی GL موجودی', 'Inventory GL Operability', 'inventory', 'costing', 'policies', 'valuation', 'layers', 'revaluations'],
    steps: [
      { route: '/inventory/costing/policies', titleKey: 'nav.inventory.costingPolicies', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/costing/valuation', titleKey: 'nav.inventory.costingValuation', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/costing/layers', titleKey: 'nav.inventory.costingLayers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/costing/revaluations', titleKey: 'nav.inventory.costingRevaluations', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/costing/operability', titleKey: 'nav.inventory.costingOperability', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-marketplace-storefront',
    titleKey: 'nav.capability.marketplaceOps',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['مدیریت فروشگاه', 'Store Manager', 'دسته‌بندی و ناوبری', 'Category and Navigation', 'چیدمان صفحه اصلی', 'Home Composer', 'بلوک‌های محتوا', 'Content Blocks', 'انتشار ویترین', 'Storefront Publishing', 'marketplace', 'storefront', 'stores', 'category', 'navigation', 'home'],
    steps: [
      { route: '/marketplace/storefront/stores', titleKey: 'nav.marketplace.storefrontStores', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/storefront/category-navigation', titleKey: 'nav.marketplace.storefrontCategoryNavigation', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/storefront/home-composer', titleKey: 'nav.marketplace.storefrontHomeComposer', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/storefront/content-blocks', titleKey: 'nav.marketplace.storefrontContentBlocks', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/storefront/publishing', titleKey: 'nav.marketplace.storefrontPublishing', whyKey: 'wayfinding.liveStep.whyApprove' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-financial-control-center',
    titleKey: 'nav.capability.ufcControlCenter',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['قابلیت‌ها', 'Capabilities', 'دفترها', 'Books', 'صندوق‌های بودجه', 'Funds', 'دوره‌های مالی', 'Fiscal Periods', 'مبنای حسابداری', 'Accounting Basis', 'ارزها', 'Currencies', 'سیاست ارزی', 'Currency Policies', 'نرخ ارز', 'FX Rates'],
    steps: [
      { route: '/financial/control-center/capabilities', titleKey: 'nav.financeControlCenterCapabilities', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/financial/control-center/books', titleKey: 'nav.financeControlCenterBooks', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/financial/control-center/funds', titleKey: 'nav.financeControlCenterFunds', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/financial/control-center/periods', titleKey: 'nav.financeControlCenterPeriods', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/financial/control-center/accounting-basis', titleKey: 'nav.financeControlCenterAccountingBasis', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/financial/control-center/currencies', titleKey: 'nav.financeControlCenterCurrencies', whyKey: 'wayfinding.liveStep.why' },
      { route: '/financial/control-center/currency-policies', titleKey: 'nav.financeControlCenterCurrencyPolicies', whyKey: 'wayfinding.liveStep.why' },
      { route: '/financial/control-center/fx-rates', titleKey: 'nav.financeControlCenterFxRates', whyKey: 'wayfinding.liveStep.why' },
      { route: '/financial/control-center/journal-policy', titleKey: 'nav.financeControlCenterJournalPolicy', whyKey: 'wayfinding.liveStep.whyApprove' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-workflow-intents',
    titleKey: 'nav.workflowIntentCreate',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['ایجاد فرمان کار', 'Create Intent', 'عملیات فرمان‌های کار', 'Intent Operations', 'حاکمیت فرمان‌های کار', 'Workflow Intent Governance', 'ارزیابی فرمان کار', 'Intent Evaluation', 'شبیه‌سازی فرمان کار', 'Intent Simulation', 'کارتابل تأیید فرمان‌های کار', 'Intent Approvals Inbox', 'workflow', 'intents', 'governance', 'evaluation'],
    steps: [
      { route: '/workflow/intents/new', titleKey: 'nav.workflowIntentCreate', whyKey: 'wayfinding.liveStep.whyCreate' },
      { route: '/workflow/intents', titleKey: 'nav.workflowIntents', whyKey: 'wayfinding.liveStep.why' },
      { route: '/workflow/intents/governance', titleKey: 'nav.workflowIntentGovernance', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/workflow/intents/evaluation', titleKey: 'nav.workflowIntentEvaluation', whyKey: 'wayfinding.liveStep.why' },
      { route: '/workflow/intents/evaluation/simulation', titleKey: 'nav.workflowIntentSimulation', whyKey: 'wayfinding.liveStep.why' },
      { route: '/workflow/intents/approvals/inbox', titleKey: 'nav.workflowIntentApprovals', whyKey: 'wayfinding.liveStep.whyApprove' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-catalog-master',
    titleKey: 'nav.capability.catalogMaster',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['آفرینگ‌ها', 'Offerings', 'دسته‌بندی‌ها', 'Categories', 'catalog', 'offerings', 'categories'],
    steps: [
      { route: '/catalog/products', titleKey: 'nav.catalog.productsHub', whyKey: 'wayfinding.liveStep.why' },
      { route: '/catalog/categories', titleKey: 'nav.catalog.categories', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-campaigns',
    titleKey: 'nav.capability.growthCampaigns',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['طرح‌های فعال‌سازی استراتژی', 'Strategy Activation Plans', 'دستیار رشد', 'Growth Concierge', 'growth', 'strategy', 'activation', 'plans', 'concierge'],
    steps: [
      { route: '/growth/strategy/activation-plans', titleKey: 'nav.growth.activationPlans', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/growth/concierge', titleKey: 'nav.growth.concierge', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-seo',
    titleKey: 'nav.capability.growthSeo',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['پروفایل SEO', 'Seo Profiles', 'پروفایل GEO', 'Geo Profiles', 'پاسخ AEO', 'Aeo Answers', 'آزمایش SXO', 'Sxo Experiments', 'growth', 'seo', 'profiles', 'search', 'geo', 'aeo', 'answers', 'sxo'],
    steps: [
      { route: '/growth/seo/profiles', titleKey: 'nav.growth.seoProfiles', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/search/geo/profiles', titleKey: 'nav.growth.geoProfiles', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/aeo/answers', titleKey: 'nav.growth.aeoAnswers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/sxo/experiments', titleKey: 'nav.growth.sxoExperiments', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-growth-consent',
    titleKey: 'nav.capability.growthConsent',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['مرکز ترجیحات', 'Preference Center', 'پیکربندی Tenant', 'Tenant Config', 'growth', 'consent', 'preference', 'center', 'tenant', 'config'],
    steps: [
      { route: '/growth/consent/preference-center', titleKey: 'nav.growth.preferenceCenter', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/growth/tenant-config', titleKey: 'nav.growth.tenantConfig', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سهمیه‌های فروش', 'Sales Quotas', 'رزروهای فروش', 'Sales Reservations', 'سیاست‌های تخصیص', 'Allocation Policies', 'سیاست‌های اعتبار', 'Credit Policies', 'سقف اعتبار مشتری', 'Customer Credit Limits', 'تصمیم‌های اعتبار', 'Credit Decisions', 'طرح‌های اقساط', 'Installment Plans', 'قراردادهای امانی', 'Consignment Contracts'],
    steps: [
      { route: '/sales/quotas', titleKey: 'nav.universalSales.quotas', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/reservations', titleKey: 'nav.universalSales.reservations', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/allocation-policies', titleKey: 'nav.universalSales.allocations', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/credit-policies', titleKey: 'nav.universalSales.creditPolicies', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/customer-credit-limits', titleKey: 'nav.universalSales.customerCreditLimits', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/credit-decisions', titleKey: 'nav.universalSales.creditDecisions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/installment-plans', titleKey: 'nav.universalSales.installments', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/sales/consignment-contracts', titleKey: 'nav.universalSales.consignments', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-gold',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['نرخ طلا', 'Gold Quotes', 'سفارش طلا', 'Gold Orders', 'sales', 'gold', 'quotes', 'orders'],
    steps: [
      { route: '/sales/gold-quotes', titleKey: 'nav.universalSales.goldQuotes', whyKey: 'wayfinding.liveStep.why' },
      { route: '/sales/gold-orders', titleKey: 'nav.universalSales.goldOrders', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-brokerage',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سفارش کارگزاری', 'Brokerage Orders', 'حساب کارگزاری', 'Brokerage Accounts', 'sales', 'brokerage', 'orders', 'accounts'],
    steps: [
      { route: '/sales/brokerage-orders', titleKey: 'nav.universalSales.brokerageOrders', whyKey: 'wayfinding.liveStep.why' },
      { route: '/sales/brokerage-accounts', titleKey: 'nav.universalSales.brokerageAccounts', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-insurance',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['پیشنهاد بیمه', 'Insurance Quotes', 'بیمه‌نامه‌ها', 'Insurance Policies', 'sales', 'insurance', 'quotes', 'policies'],
    steps: [
      { route: '/sales/insurance-quotes', titleKey: 'nav.universalSales.insuranceQuotes', whyKey: 'wayfinding.liveStep.why' },
      { route: '/sales/insurance-policies', titleKey: 'nav.universalSales.insurancePolicies', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-credit',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سیاست‌های اعتبار', 'Credit Policies', 'تصمیم‌های اعتبار', 'Credit Decisions', 'sales', 'credit', 'policies', 'decisions'],
    steps: [
      { route: '/sales/credit-policies', titleKey: 'nav.universalSales.creditPolicies', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/sales/credit-decisions', titleKey: 'nav.universalSales.creditDecisions', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-distribution',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['پخش مسیرها', 'Route dispatch', 'تسویه میدانی', 'Field settlements', 'sales', 'distribution', 'routes', 'settlements'],
    steps: [
      { route: '/sales/distribution-routes', titleKey: 'nav.universalSales.distributionRoutes', whyKey: 'wayfinding.liveStep.why' },
      { route: '/sales/distribution-settlements', titleKey: 'nav.universalSales.distributionSettlements', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-sales-setup-sales-ai',
    titleKey: 'nav.capability.salesSetup',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['پیشنهادهای هوش مصنوعی', 'AI Recommendations', 'حاکمیت مدل AI', 'AI Model Governance', 'sales', 'recommendations', 'models'],
    steps: [
      { route: '/sales/ai-recommendations', titleKey: 'nav.universalSales.aiRecommendations', whyKey: 'wayfinding.liveStep.why' },
      { route: '/sales/ai-models', titleKey: 'nav.universalSales.aiModels', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-inventory-warehousing',
    titleKey: 'nav.capability.inventoryWarehousing',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['انبارها', 'Warehouses', 'شاخص‌های انبار', 'Inventory KPIs', 'ورود کالا (ASN)', 'Inbound (ASN)', 'برگه درخواست', 'Stock Requisitions', 'سیاست تجدید موجودی', 'Replenishment Policies', 'هشدار min/max', 'Replenishment Alerts', 'وضعیت انقضا', 'Expiry Status', 'گزارش‌های رسمی انبار', 'Official inventory reports'],
    steps: [
      { route: '/inventory/warehouses', titleKey: 'nav.inventory.warehouses', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/kpi-dashboard', titleKey: 'nav.inventory.kpiDashboard', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/inbound-shipments', titleKey: 'nav.inventory.inboundShipments', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/requisitions', titleKey: 'nav.inventory.requisitions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/replenishment-policies', titleKey: 'nav.inventory.replenishmentPolicies', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/replenishment-breaches', titleKey: 'nav.inventory.replenishmentBreaches', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/expiry-status', titleKey: 'nav.inventory.expiryStatus', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/reports', titleKey: 'nav.inventory.officialReports', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-inventory-warehousing-inventory-replenishment',
    titleKey: 'nav.capability.inventoryWarehousing',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سیاست تجدید موجودی', 'Replenishment Policies', 'هشدار min/max', 'Replenishment Alerts', 'inventory', 'replenishment', 'policies', 'breaches'],
    steps: [
      { route: '/inventory/replenishment-policies', titleKey: 'nav.inventory.replenishmentPolicies', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/replenishment-breaches', titleKey: 'nav.inventory.replenishmentBreaches', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-inventory-tracking',
    titleKey: 'nav.capability.inventoryTracking',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['لات‌ها', 'Lots', 'سریال‌ها', 'Serials', 'ردیابی', 'Traceability', 'داشبورد ردیابی', 'Tracking Dashboard', 'inventory', 'lots', 'serials', 'traceability', 'tracking', 'dashboard'],
    steps: [
      { route: '/inventory/lots', titleKey: 'nav.inventory.lots', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/serials', titleKey: 'nav.inventory.serials', whyKey: 'wayfinding.liveStep.why' },
      { route: '/inventory/traceability', titleKey: 'nav.inventory.traceability', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/tracking-dashboard', titleKey: 'nav.inventory.trackingDashboard', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-inventory-quality',
    titleKey: 'nav.capability.inventoryQuality',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['بازرسی QC', 'QC Inspections', 'فراخوان‌ها', 'Recalls', 'inventory', 'inspections', 'recalls'],
    steps: [
      { route: '/inventory/qc-inspections', titleKey: 'nav.inventory.qcInspections', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/inventory/recalls', titleKey: 'nav.inventory.recalls', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-service-orders',
    titleKey: 'nav.capability.serviceOrders',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سفارش سرویس', 'Service Orders', 'منابع سرویس', 'Service Resources', 'services', 'orders', 'resources'],
    steps: [
      { route: '/services/orders', titleKey: 'nav.service.orders', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/services/resources', titleKey: 'nav.service.resources', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-service-boards',
    titleKey: 'nav.capability.serviceBoards',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['تابلوی دیسپچ', 'Dispatch Board', 'صف تکنسین', 'Technician Queue', 'services', 'dispatch', 'board', 'technician'],
    steps: [
      { route: '/services/dispatch-board', titleKey: 'nav.service.dispatchBoard', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/services/technician', titleKey: 'nav.service.technician', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-rental-operations',
    titleKey: 'nav.capability.rentalOperations',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['قراردادهای اجاره', 'Rental Agreements', 'تابلوی رزرو', 'Booking Board', 'rental', 'agreements', 'booking', 'board'],
    steps: [
      { route: '/rental/agreements', titleKey: 'nav.rental.agreements', whyKey: 'wayfinding.liveStep.why' },
      { route: '/rental/booking-board', titleKey: 'nav.rental.bookingBoard', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-hospitality-operations',
    titleKey: 'nav.capability.hospitalityOperations',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['تقویم نرخ', 'Rate Calendar', 'املاک', 'Properties', 'رزروها', 'Reservations', 'تابلوی پذیرش', 'Front Desk Board', 'داشبورد KPI هتل‌داری', 'Hospitality KPI Dashboard', 'تقویم رزرو', 'Reservation Calendar', 'نگهداری اتاق', 'Room Maintenance', 'تابلوی نظافت', 'Housekeeping Board'],
    steps: [
      { route: '/hospitality/rate-calendar', titleKey: 'nav.hospitality.rateCalendar', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/hospitality/properties', titleKey: 'nav.hospitality.properties', whyKey: 'wayfinding.liveStep.why' },
      { route: '/hospitality/reservations', titleKey: 'nav.hospitality.reservations', whyKey: 'wayfinding.liveStep.why' },
      { route: '/hospitality/front-desk', titleKey: 'nav.hospitality.frontDesk', whyKey: 'wayfinding.liveStep.why' },
      { route: '/hospitality/kpi-dashboard', titleKey: 'nav.hospitality.kpiDashboard', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/hospitality/booking-board', titleKey: 'nav.hospitality.bookingBoard', whyKey: 'wayfinding.liveStep.why' },
      { route: '/hospitality/room-maintenance', titleKey: 'nav.hospitality.roomMaintenance', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/hospitality/housekeeping', titleKey: 'nav.hospitality.housekeeping', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/hospitality/policy-exceptions', titleKey: 'nav.hospitality.policyExceptions', whyKey: 'wayfinding.liveStep.whyApprove' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-subscription-billing',
    titleKey: 'nav.capability.subscriptionBilling',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['اشتراک محصول', 'Product Subscriptions', 'ماژول‌های تجاری', 'Commercial Modules', 'پلن‌های تجاری', 'Commercial Plans', 'افزونه‌های تجاری', 'Commercial Add-ons', 'subscription', 'contracts', 'commercial', 'modules', 'plans', 'add', 'ons'],
    steps: [
      { route: '/subscription/contracts', titleKey: 'nav.subscription.contracts', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/commercial/modules', titleKey: 'nav.commercial.modules', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/commercial/plans', titleKey: 'nav.commercial.plans', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/commercial/add-ons', titleKey: 'nav.commercial.addons', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-marketplace-ops',
    titleKey: 'nav.capability.marketplaceOps',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['راهکارهای صنعتی', 'Industry Solutions', 'عملیات مارکت‌پلیس', 'Marketplace Operations', 'آمادگی لانچ', 'Launch Readiness', 'جست‌وجو و بهینه‌سازی', 'Search & Optimization', 'فروشندگان مارکت‌پلیس', 'Marketplace Sellers', 'marketplace', 'industry', 'solutions', 'dashboard', 'launch', 'readiness'],
    steps: [
      { route: '/marketplace/industry-solutions', titleKey: 'nav.marketplace.industrySolutions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/dashboard', titleKey: 'nav.marketplace.dashboard', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/marketplace/launch-readiness', titleKey: 'nav.marketplace.launchReadiness', whyKey: 'wayfinding.liveStep.why' },
      { route: '/marketplace/optimization', titleKey: 'nav.marketplace.optimization', whyKey: 'wayfinding.liveStep.why' },
      { route: '/marketplace/sellers', titleKey: 'nav.marketplace.sellers', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-cmms-maintenance',
    titleKey: 'nav.capability.cmmsMaintenance',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['دستور کار', 'Work Orders', 'برنامه نگهداری', 'Maintenance Plans', 'داشبورد توقف', 'Downtime Dashboard', 'cmms', 'work', 'orders', 'plans', 'downtime'],
    steps: [
      { route: '/cmms/work-orders', titleKey: 'nav.cmms.workOrders', whyKey: 'wayfinding.liveStep.why' },
      { route: '/cmms/plans', titleKey: 'nav.cmms.plans', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/cmms/downtime', titleKey: 'nav.cmms.downtime', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-insurance-pas',
    titleKey: 'nav.capability.insurancePas',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['استودیو محصول', 'Product Studio', 'مدیریت قالب‌های چاپ', 'Print Templates', 'نسخه‌های محصول', 'Product Versions', 'نرخ‌گذاری', 'Rating', 'میز بیمه‌نامه‌ها', 'Policies Desk', 'insurance', 'products', 'print', 'templates', 'product', 'versions'],
    steps: [
      { route: '/insurance/products', titleKey: 'nav.insurance.products', whyKey: 'wayfinding.liveStep.why' },
      { route: '/insurance/print-templates', titleKey: 'nav.insurance.printTemplates', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/insurance/product-versions', titleKey: 'nav.insurance.productVersions', whyKey: 'wayfinding.liveStep.why' },
      { route: '/insurance/rating', titleKey: 'nav.insurance.rating', whyKey: 'wayfinding.liveStep.why' },
      { route: '/insurance/policies', titleKey: 'nav.insurance.policies', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-insurance-quote-proposal-bind',
    titleKey: 'nav.capability.insuranceQuoteProposal',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['استعلام‌های بیمه', 'Insurance Quotes', 'پیشنهادهای بیمه', 'Insurance Proposals', 'insurance', 'quotes', 'proposals'],
    steps: [
      { route: '/insurance/quotes', titleKey: 'nav.insurance.quotes', whyKey: 'wayfinding.liveStep.why' },
      { route: '/insurance/proposals', titleKey: 'nav.insurance.proposals', whyKey: 'wayfinding.liveStep.why' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-insurance-underwriting',
    titleKey: 'nav.capability.insuranceUnderwriting',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['صندوق ارزیابی ریسک', 'UW Inbox', 'پیشنهادهای هوشمند', 'AI Recommendations', 'insurance', 'cases', 'recommendations'],
    steps: [
      { route: '/insurance/uw-cases', titleKey: 'nav.insurance.uw', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/insurance/ai-recommendations', titleKey: 'nav.insurance.aiRecommendations', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-insurance-distribution',
    titleKey: 'nav.capability.insuranceDistribution',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['رجیستری تولیدکنندگان', 'Producer Registry', 'مدیریت توزیع', 'Distribution Admin', 'insurance', 'producers', 'distribution'],
    steps: [
      { route: '/insurance/producers', titleKey: 'nav.insurance.producers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/insurance/distribution', titleKey: 'nav.insurance.distribution', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-insurance-commissions',
    titleKey: 'nav.capability.insuranceCommissions',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['پلن‌های کمیسیون', 'Commission Plans', 'تعهدات کمیسیون', 'Commission Accruals', 'تسویه کمیسیون', 'Commission Settlements', 'insurance', 'commission', 'plans', 'accruals', 'settlements'],
    steps: [
      { route: '/insurance/commission-plans', titleKey: 'nav.insurance.commissionPlans', whyKey: 'wayfinding.liveStep.whyPlan', optional: true },
      { route: '/insurance/commission-accruals', titleKey: 'nav.insurance.commissionAccruals', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/insurance/commission-settlements', titleKey: 'nav.insurance.commissionSettlements', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-dynamic-forms',
    titleKey: 'nav.dynamicImportExport',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['ورود / خروج', 'Import / Export', 'تحلیل فرم', 'Form Analytics', 'کاتالوگ فروشگاه', 'Storefront Catalog', 'dynamic', 'import', 'export', 'analytics', 'storefront', 'catalog'],
    steps: [
      { route: '/dynamic/import-export', titleKey: 'nav.dynamicImportExport', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/dynamic/analytics', titleKey: 'nav.dynamicAnalytics', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/dynamic/storefront-catalog', titleKey: 'nav.dynamicStorefrontCatalog', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-notifications-ops',
    titleKey: 'nav.capability.notificationsOps',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['گزارش پیام‌ها', 'Message log', 'قالب اعلان', 'Templates', 'حساب‌های ارسال', 'Provider accounts', 'کنسول تحویل', 'Delivery console', 'سهمیه و سیاست', 'Quotas & policy', 'notifications', 'messages', 'templates', 'providers', 'delivery', 'policy'],
    steps: [
      { route: '/notifications/messages', titleKey: 'nav.notifications.messages', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/notifications/templates', titleKey: 'nav.notifications.templates', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/notifications/providers', titleKey: 'nav.notifications.providers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/notifications/delivery', titleKey: 'nav.notifications.delivery', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/notifications/policy', titleKey: 'nav.notifications.policy', whyKey: 'wayfinding.liveStep.whyApprove' }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-ncx-ops',
    titleKey: 'nav.capability.ncxOps',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['سفارش‌های راه‌اندازی', 'Provisioning Orders', 'مرکز کنترل', 'Control Center', 'شماره‌ها و انتقال شماره', 'Numbers & Porting', 'داخلی‌ها و پایانه‌ها', 'Extensions & Endpoints', 'حضور', 'Agent Presence', 'صف‌ها', 'Queues & SLA', 'قواعد مسیریابی', 'Routing Rules', 'پاسخ‌گوی صوتی تعاملی', 'IVR Flows'],
    steps: [
      { route: '/comms/provisioning-orders', titleKey: 'nav.comms.provisioning', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/control-center', titleKey: 'nav.comms.controlCenter', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/numbers', titleKey: 'nav.comms.numbers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/extensions', titleKey: 'nav.comms.extensions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/agent-presence', titleKey: 'nav.comms.presence', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/queues', titleKey: 'nav.comms.queues', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/routing-rules', titleKey: 'nav.comms.routing', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/ivr-flows', titleKey: 'nav.comms.ivr', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/interactions', titleKey: 'nav.comms.interactions', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/qa', titleKey: 'nav.comms.qa', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/analytics', titleKey: 'nav.comms.analytics', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/agent-workspace', titleKey: 'nav.comms.workspace', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  },
  {
    id: 'play-crawled-ncx-platform-admin',
    titleKey: 'nav.capability.ncxPlatformAdmin',
    descriptionKey: 'wayfinding.livePlay.description',
    synonyms: ['تلفن و مجوزها', 'Telephony & Entitlements', 'نمایه‌های اپراتور', 'Carrier Profiles', 'مصرف', 'Usage & Reconciliation', 'آمادگی برنامه', 'Program Readiness', 'comms', 'telephony', 'carrier', 'profiles', 'usage', 'billing', 'program', 'readiness'],
    steps: [
      { route: '/comms/telephony', titleKey: 'nav.comms.telephony', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/carrier-profiles', titleKey: 'nav.comms.carriers', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/usage-billing', titleKey: 'nav.comms.usage', whyKey: 'wayfinding.liveStep.why', optional: true },
      { route: '/comms/program-readiness', titleKey: 'nav.comms.programReadiness', whyKey: 'wayfinding.liveStep.why', optional: true }
    ],
    intentKey: 'workflow.process.start'
  }
];
